import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';
import { ApiDomains } from '../../contexts/FetchContext';

export const ImpostazioneContext = React.createContext(null);

const { Provider } = ImpostazioneContext;

export const ImpostazioneProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        impostazione: null,
        iconFiles: [],
    });

    const { iconFiles } = state;

    const [isLoadingImpostazione, setIsLoadingImpostazione] = useState(false);
    const getImpostazioneAsync = async () => {
        try {
            setIsLoadingImpostazione(true);
            const r = await fetchAuthorized(ApiRoutes.Impostazione.GetImpostazione(), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            setState({ impostazione: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingImpostazione(false);
        }
    }

    const [isUpdatingImpostazione, setIsUpdatingImpostazione] = useState(false);
    const updateImpostazioneAsync = async (impostazione) => {
        try {
            setIsUpdatingImpostazione(true);
            if (window.confirm("Confermare la modifica?")){
            const r = await fetchAuthorized(ApiRoutes.Impostazione.UpdateImpostazione(), {
                method: HttpMethods.POST,
                body: JSON.stringify(impostazione),
            });
            const result = await r.json();
            setState({ impostazione: result });
            showSuccessMessage("Impostazioni aggiornate");
        }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingImpostazione(false);
        }
    }

    const [isAddingFile, setIsAddingFile] = useState(false);
    const addFileAsync = async (file) => {
        try {
            setIsAddingFile(true);

            var formData = new FormData();
            formData.append("formFile", file);

            const r = await fetchAuthorized(ApiRoutes.File.AddFile(), {
                method: HttpMethods.PUT,
                body: formData,
            });
            const result = await r.json();
            showSuccessMessage("File caricato");
            return `${ApiDomains.GiustiziaMap}/File/${result.id}`;
        } catch (e) {
            console.debug(e);
        } finally {
            setIsAddingFile(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingImpostazione,
            getImpostazioneAsync,

            isUpdatingImpostazione,
            updateImpostazioneAsync,

            isAddingFile,
            addFileAsync,

            isAddingFile,
            addFileAsync,
        }}>
            {props.children}
        </Provider>
    );
}